import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API_URL } from "@/lib/site";

const EMPTY = { name: "", phone: "", product: "", message: "" };

export const EnquiryForm = ({ initialProduct = "" }) => {
  const [form, setForm] = useState({ ...EMPTY, product: initialProduct });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API_URL}/enquiries`, form);
      toast.success("Enquiry sent! We will get back to you shortly.");
      setForm(EMPTY);
    } catch (err) {
      toast.error("Could not send your enquiry. Please call or WhatsApp us instead.");
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    "w-full px-3 py-2.5 rounded border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm";

  return (
    <div className="bg-white rounded-xl p-8 text-slate-900 shadow-xl" data-testid="enquiry-form-card">
      <h3 className="text-lg font-bold text-slate-950 mb-1">Product &amp; Price Enquiry</h3>
      <p className="text-xs text-slate-500 mb-6">Send your requirements and we will reply promptly.</p>

      <form className="space-y-4" onSubmit={submit} data-testid="enquiry-form">
        <div>
          <label htmlFor="enquiry-name" className="block text-xs font-bold text-slate-700 uppercase mb-1">Your Name</label>
          <input id="enquiry-name" data-testid="enquiry-name-input" type="text" required minLength={2} maxLength={80}
            className={inputCls} placeholder="Full name" value={form.name} onChange={set("name")} />
        </div>
        <div>
          <label htmlFor="enquiry-phone" className="block text-xs font-bold text-slate-700 uppercase mb-1">Phone Number</label>
          <input id="enquiry-phone" data-testid="enquiry-phone-input" type="tel" required minLength={8} maxLength={20}
            className={inputCls} placeholder="Your mobile number" value={form.phone} onChange={set("phone")} />
        </div>
        <div>
          <label htmlFor="enquiry-product" className="block text-xs font-bold text-slate-700 uppercase mb-1">Product Details</label>
          <input id="enquiry-product" data-testid="enquiry-product-input" type="text" maxLength={120}
            className={inputCls} placeholder="E.g. LED TV, 5G Mobile, Microwave" value={form.product} onChange={set("product")} />
        </div>
        <div>
          <label htmlFor="enquiry-message" className="block text-xs font-bold text-slate-700 uppercase mb-1">Message</label>
          <textarea id="enquiry-message" data-testid="enquiry-message-input" rows={3} required minLength={5} maxLength={1000}
            className={inputCls} placeholder="Ask for latest discount or delivery options..." value={form.message} onChange={set("message")} />
        </div>
        <button
          type="submit"
          data-testid="enquiry-submit-button"
          disabled={sending}
          className="w-full py-3 bg-blue-700 hover:bg-blue-600 disabled:opacity-60 text-white font-bold rounded uppercase tracking-wider text-xs transition-colors"
        >
          {sending ? "Sending..." : "Submit Product Enquiry"}
        </button>
        <p className="text-[10px] text-center text-slate-500 mt-2">We never share your contact details.</p>
      </form>
    </div>
  );
};
